export class Message {
  message: string;
  type: string;

  constructor() {
    this.message = '';
    this.type = 'info';
  }
}
